// Extracts a generator run id from a 3D Studio detail URL.
//
// Current contract — kept in sync with the URL produced by
// Pods/ThreeDStudio/Shared/ShareContent/ThreeDStudioShareContent.jsx:
//   /ai-3d-model-generator/3d-models/<slug>-<numericRunId>
//
// Returns the numeric id, or null when the path does not point at a known
// shared-run detail URL. Under the URL-is-source-of-truth contract, callers
// use null to mean "no model is open" for /ai, gallery, and unrelated paths.
//
// If the URL scheme changes — e.g. to a pure slug without the trailing id —
// update this parser AND its tests. Without a recoverable id in the URL,
// client-side back/forward navigation cannot rehydrate the shared run; the
// remediation in that case is a server lookup (slug -> run id) reached via
// a new API endpoint. Keep this comment honest if you change the format.
const SHARED_RUN_PATHNAME_REGEX = /^\/ai-3d-model-generator\/3d-models\/(?:[^/]*-)?(\d+)\/?$/

export const parseRunIdFromPathname = (pathname) => {
  if (typeof pathname !== 'string') {
    return null
  }
  const match = pathname.match(SHARED_RUN_PATHNAME_REGEX)
  if (!match) {
    return null
  }
  const parsed = Number(match[1])
  return Number.isFinite(parsed) ? parsed : null
}

export default parseRunIdFromPathname
